import { environment } from "../../environments/environment";

const base = () => environment.babErpUrl.replace(/\/$/, "");

/** ERP work request page — `{erp}/work-requests/{uuid}` */
export const erpWorkRequestUrl = (workRequestId: string) =>
  `${base()}/work-requests/${workRequestId}`;

/**
 * ERP export unit — the read-only detail page for the exported week a booking
 * was created from: `{erp}/crm/booking-export/{exportUnitId}`. The id is the
 * booking's `erpExportUnitRef`.
 */
export const erpExportUnitUrl = (exportUnitId: string) =>
  `${base()}/crm/booking-export/${exportUnitId}`;
